import type { ScheduledMessage } from './types';

/**
 * The API doesn't accept the non-alpha characters, so we have to filter those out
 * see: /Iterable/platform/app/models/MessageMedium.scala
 */
const AlphaRegExp = new RegExp('[a-zA-Z]');

export const convertLabelToApiFormat = (label = '') =>
  Array.from(label).reduce((textAccumulator, text) => {
    if (AlphaRegExp.test(text)) {
      return textAccumulator + text;
    }

    return textAccumulator;
  }, '');

/**
 * Filter fn used for the scheduled messages table filter
 */
export const scheduledMessagesFilterFn = (scheduledMessage: ScheduledMessage, filter: string) => {
  if (scheduledMessage.campaignName?.toLowerCase().includes(filter.toLowerCase())) {
    return true;
  }
  if (scheduledMessage.email?.toLowerCase().includes(filter.toLowerCase())) {
    return true;
  }
  if (String(scheduledMessage.id)?.includes(filter.toLowerCase())) {
    return true;
  }
  if (String(scheduledMessage.campaignId)?.includes(filter.toLowerCase())) {
    return true;
  }

  return false;
};
